import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	marketUpdate: null,
	menu: null
}

const mylistSlice = createSlice({
	name: 'mylist',
	initialState,
	reducers: {
		initialMylist: (state, { payload }) => {
			state.marketUpdate = payload.tb_my_list_market_update
			state.menu = payload.tb_my_list_menu
		},
		setMylist: () => {
			//
		}
	}
})

export const { initialMylist, setMylist } = mylistSlice.actions

export default mylistSlice.reducer
